<div class="prospect-actions">
  <div class="grid-appearance">
    <label class="dim-toggle">
      <input type="checkbox" role="switch" [checked]="dimSurroundings" (change)="onDimToggle($event)" />
      <span>Dim surroundings</span>
    </label>
    <div class="grid-colors" role="group" aria-label="Grid color">
      <button *ngFor="let color of gridColors" type="button" class="grid-color br-focus-ring"
              [style.background-color]="color.value" [attr.aria-label]="color.label + ' grid'"
              [title]="color.label + ' grid'" [attr.aria-pressed]="prospectFeature.color === color.value"
              (click)="prospectFeature.setColor(color.value)"></button>
    </div>
  </div>

  <div class="br-view-switch br-view-switch--quiet cell-size-picker" role="group" aria-label="Approximate cell size">
    <button *ngFor="let size of cellSizeOptions" type="button" class="br-view"
            [class.br-view--on]="prospectFeature.cellZoomLevel === size.zoom"
            [attr.aria-pressed]="prospectFeature.cellZoomLevel === size.zoom"
            title="Approximate size; actual dimensions vary by latitude"
            (click)="onCellSizeChange(size.zoom)">
      <span>{{ size.label }}</span>
      <span class="cell-dimensions">{{ size.approximateMeters }} × {{ size.approximateMeters }} m</span>
    </button>
  </div>

  <button type="button" class="br-btn br-btn--primary br-w-full pull-selected" (click)="openPullDialog()"
          [disabled]="selectionCount === 0 || submitting || !auth.hasPermission('Lead.Manage')">
    {{ submitting ? 'Starting…' : selectionCount ? 'Pull ' + selectionCount + ' selected ' + (selectionCount === 1 ? 'cell' : 'cells') : 'Select cells to pull' }}
  </button>

  <p *ngIf="!auth.hasPermission('Lead.Manage')" class="br-text-muted br-small br-mb-0">Lead management permission is required to discover leads.</p>
  <p *ngIf="error" class="br-text-danger br-small br-mb-0" role="alert">{{ error }}</p>
</div>
